var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "neu-card-ctn mx-auto" }, [
    _c(
      "div",
      { staticClass: "neu-card mx-auto" },
      [
        _vm.src !=
          "/static-appopensalud/img/icons/morillas-svg-icons/Logo/logo-receta.png" &&
        _vm.src !=
          "/static-appopensalud/img/icons/morillas-svg-icons/Logo/iso.png"
          ? _c("base-icon", {
              staticClass: "icon-width",
              attrs: {
                src: _vm.src,
                blue: "",
                fullWidth: "",
                shadow: "",
                color: _vm.iconColor
              }
            })
          : _vm._e(),
        _vm._v(" "),
        _vm.src ==
        "/static-appopensalud/img/icons/morillas-svg-icons/Logo/iso.png"
          ? _c("img", {
              staticClass: " vertical img-icon icon-width",
              staticStyle: { width: "7.7em", height: "7.7em" },
              attrs: {
                src:
                  "/static-appopensalud/img/icons/morillas-svg-icons/Logo/iso.png"
              }
            })
          : _vm._e(),
        _vm._v(" "),
        _c("div", { staticClass: "subtitle-card" }, [
          _c("p", { domProps: { innerHTML: _vm._s(_vm.paddedTitle) } }),
          _vm._v(" "),
          _c("span", { domProps: { innerHTML: _vm._s(_vm.paddedSubtitle) } })
        ])
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-31fa0e7a", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-31fa0e7a","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/base/ui/NeuCardFunctions.vue
// module id = 2510
// module chunks = 10 12 30 31 35 36 39 40 41 42 44 50 52 59